import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  getPublishedFormEditorForms,
  getUnpublishedFormEditorForms,
  selectForm,
} from '../../store/slices/formEditorSlice';
import { getFormEditorFormThunk } from '../../store/thunks/formEditorThunks';

export const FormsListCardView = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const publishedForms = useSelector(getPublishedFormEditorForms);
  const unpublishedForms = useSelector(getUnpublishedFormEditorForms);

  useEffect(() => {
    dispatch(getFormEditorFormThunk());
  }, []);

  const onSelectForm = (form) => {
    dispatch(selectForm(form));
    history.push(`/form-editor/${form.id}`);
  };

  return (
    <>
      <div>
        <h2 style={{ color: 'white', fontSize: 18, fontWeight: 700 }}>
          Julkaistut
        </h2>
        {publishedForms && publishedForms.length > 0 && (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
              gap: '1.5rem',
              padding: '1rem',
            }}
          >
            {publishedForms.map((form) => (
              <div
                key={form.id}
                onClick={() => onSelectForm(form)}
                style={{
                  cursor: 'pointer',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  backgroundColor: '#005a7f',
                  backdropFilter: 'blur(12px)',
                  WebkitBackdropFilter: 'blur(12px)',
                  padding: '1rem',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow =
                    '0 12px 32px rgba(74, 211, 255, 0.3)';
                  e.currentTarget.style.backgroundColor =
                    'rgba(74, 211, 255, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.backgroundColor = '#005a7f';
                }}
              >
                <iframe
                  src={form.mediaUrl || form?.mediaUrls[0]}
                  title={form.name}
                  style={{
                    width: '100%',
                    height: '200px',
                    border: 'none',
                    marginBottom: '0.75rem',
                    pointerEvents: 'none',
                  }}
                />
                <div
                  style={{
                    fontWeight: '600',
                    fontSize: '1rem',
                    textAlign: 'center',
                    color: '#fff',
                    wordWrap: 'break-word',
                  }}
                >
                  {form.name || 'Nimeämätön lomakepohja'}
                </div>
              </div>
            ))}
          </div>
        )}

        <h2 style={{ color: 'white', fontSize: 18, fontWeight: 700 }}>
          Julkaisemattomat
        </h2>
        {unpublishedForms && unpublishedForms.length > 0 && (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
              gap: '1.5rem',
              padding: '1rem',
            }}
          >
            {unpublishedForms.map((form) => (
              <div
                key={form.id}
                onClick={() => onSelectForm(form)}
                style={{
                  cursor: 'pointer',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  backgroundColor: '#005a7f',
                  backdropFilter: 'blur(12px)',
                  WebkitBackdropFilter: 'blur(12px)',
                  padding: '1rem',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow =
                    '0 12px 32px rgba(74, 211, 255, 0.3)';
                  e.currentTarget.style.backgroundColor =
                    'rgba(74, 211, 255, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.backgroundColor = '#005a7f';
                }}
              >
                <iframe
                  src={form.mediaUrl || form?.mediaUrls[0]}
                  title={form.name}
                  style={{
                    width: '100%',
                    height: '200px',
                    border: 'none',
                    marginBottom: '0.75rem',
                    pointerEvents: 'none',
                  }}
                />
                <div
                  style={{
                    fontWeight: '600',
                    fontSize: '1rem',
                    textAlign: 'center',
                    color: '#fff',
                    wordWrap: 'break-word',
                  }}
                >
                  {form.name || 'Nimeämätön lomakepohja'}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};
